import React, { Component } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  Divider,
  IconButton,
  FormControlLabel,
  Checkbox,
  DialogTitle,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import { Close, Save, Edit, ExpandMore, Refresh } from '@mui/icons-material';

import AdminAPI from '../service/AdminAPI';

class UpdateProductsPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      cachedProducts: null,
      products: []
    }
  }

  handleShow = (title) => this.setState({ show: true, title });

  handleClose = () => {
    this.setState({ show: false });
    this.props.onClose();
  }

  handleSubmit = (ev) => {
    AdminAPI.UpdateProducts({ products: this.state.cachedProducts })
      .then((_res) => {
        window.location.reload();
      })
      .catch(console.error);

    ev.preventDefault();
  }

  componentDidUpdate() {
    if (this.state.show !== this.props.show) {
      this.setState({ show: this.props.show, products: this.props.products, cachedProducts: this.props.products.map(p => { return { ...p } }) });
    }
  }

  handleNameChange = (ev, productID) => {
    var _ind = this.state.products.findIndex(_product => _product.ID === productID);

    if (_ind === -1) {
      return;
    }

    this.state.cachedProducts[_ind].Name = ev.target.value;

    this.setState({ products: this.state.products });
  }

  handleSortIDChange = (ev, productID) => {
    var _ind = this.state.products.findIndex(_product => _product.ID === productID);

    if (_ind === -1) {
      return;
    }

    this.state.cachedProducts[_ind].SortID = parseInt(ev.target.value);

    this.setState({ products: this.state.products });
  }

  handlePriceChange = (val, productID) => {
    var _ind = this.state.products.findIndex(_product => _product.ID === productID);

    if (_ind === -1) {
      return;
    }

    this.state.cachedProducts[_ind].Price = val;

    this.setState({ products: this.state.products });
  }

  handleWeightChange = (val, productID) => {
    var _ind = this.state.products.findIndex(_product => _product.ID === productID);

    if (_ind === -1) {
      return;
    }

    this.state.cachedProducts[_ind].Weight = val;

    this.setState({ products: this.state.products });
  }

  updateFixedValues = (hasFixedValues, productID) => {
    var _ind = this.state.products.findIndex(_product => _product.ID === productID);

    if (_ind === -1) {
      return;
    }

    this.state.cachedProducts[_ind].Price = hasFixedValues ? 1 : 0;
    this.state.cachedProducts[_ind].Weight = hasFixedValues ? 1 : 0;
    this.state.cachedProducts[_ind].isFixed = hasFixedValues;

    this.setState({ products: this.state.products });
  }

  resetEntry = (productID) => {
    var _ind = this.state.products.findIndex(_product => _product.ID === productID);

    if (_ind === -1) {
      return;
    }

    this.state.cachedProducts[_ind].Name = this.state.products[_ind].Name;
    this.state.cachedProducts[_ind].Price = this.state.products[_ind].Price;
    this.state.cachedProducts[_ind].Weight = this.state.products[_ind].Weight;
    this.state.cachedProducts[_ind].isFixed = this.state.products[_ind].isFixed;
    this.state.cachedProducts[_ind].SortID = this.state.products[_ind].SortID;

    this.setState({ cachedProducts: this.state.cachedProducts });
  }

  render() {
    return (
      this.state.cachedProducts ?
        (
          <Dialog
            open={this.state.show}
            onHide={this.handleClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: { xs: '12px', sm: '20px' },
                overflow: 'hidden',
                margin: { xs: '16px', sm: '32px' },
                maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' }
              }
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={this.handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'white',
                zIndex: 1,
                '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }
              }}
            >
              <Close />
            </IconButton>

            {/* Header with gradient */}
            <Box
              sx={{
                background: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
                pt: { xs: 3, sm: 4 },
                pb: { xs: 2.5, sm: 3 },
                px: { xs: 2, sm: 3 },
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                gap: { xs: 1.5, sm: 2 }
              }}
            >
              <Edit sx={{ fontSize: { xs: '1.8rem', sm: '2.5rem' } }} />
              <DialogTitle sx={{ p: 0, flex: 1 }}>
                <Typography variant="h5" sx={{ fontWeight: 700, color: 'white', fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
                  Produkt Übersicht
                </Typography>
              </DialogTitle>
            </Box>

            <DialogContent sx={{ pt: { xs: 2, sm: 3 }, pb: { xs: 1, sm: 2 }, px: { xs: 2, sm: 3 } }}>
              <Box component="form" onSubmit={this.handleSubmit} id="update-products-form">
                {this.state.cachedProducts.map((_product, index) => (
                  <Accordion
                    key={_product.ID}
                    defaultExpanded={index === 0}
                    sx={{
                      mb: 2,
                      borderRadius: '12px !important',
                      '&:before': { display: 'none' },
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      sx={{
                        bgcolor: '#f5f5f5',
                        borderRadius: '12px',
                        '&:hover': { bgcolor: '#e8f5e9' }
                      }}
                    >
                      <Typography sx={{ fontWeight: 600 }}>{_product.Name}</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ pt: 3 }}>
                      <TextField
                        fullWidth
                        label="Produktname"
                        name={_product.Name}
                        value={_product.Name}
                        onChange={(ev) => this.handleNameChange(ev, _product.ID)}
                        sx={{ mb: 3 }}
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={_product.isFixed}
                            onChange={() => this.updateFixedValues(!_product.isFixed, _product.ID)}
                          />
                        }
                        label="Hat dieses Produkt ein fixiertes Gewicht und somit einen fixierten Preis?"
                        sx={{ mb: 3 }}
                      />

                      {_product.isFixed && (
                        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 3 }}>
                          <TextField
                            fullWidth
                            type="number"
                            label="Gewicht (Kg/L)"
                            name="weight"
                            value={_product.Weight}
                            onChange={(ev) => this.handleWeightChange(ev.target.value, _product.ID)}
                            inputProps={{ min: 0, step: 0.01 }}
                          />

                          <TextField
                            fullWidth
                            type="number"
                            label="Preis (€)"
                            name="Price"
                            value={_product.Price}
                            onChange={(ev) => this.handlePriceChange(ev.target.value, _product.ID)}
                            inputProps={{ min: 0, step: 0.01 }}
                          />
                        </Box>
                      )}

                      <Button
                        fullWidth
                        variant="outlined"
                        startIcon={<Refresh />}
                        onClick={() => this.resetEntry(_product.ID)}
                        sx={{
                          borderRadius: '10px',
                          textTransform: 'none',
                          fontWeight: 600,
                          borderColor: '#ddd',
                          color: '#666',
                          '&:hover': {
                            borderColor: '#bbb',
                            bgcolor: '#f5f5f5'
                          }
                        }}
                      >
                        Zurücksetzen
                      </Button>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Box>
            </DialogContent>

            <Divider />

            <DialogActions sx={{ 
              p: { xs: 2, sm: 3 }, 
              gap: { xs: 1.5, sm: 2 },
              flexDirection: { xs: 'column', sm: 'row' }
            }}>
              <Button
                onClick={this.handleClose}
                variant="outlined"
                size="large"
                fullWidth
                sx={{
                  borderRadius: '10px',
                  textTransform: 'none',
                  fontWeight: 600,
                  borderColor: '#ddd',
                  color: '#666',
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                  py: { xs: 1.2, sm: 1.5 },
                  order: { xs: 2, sm: 1 },
                  '&:hover': {
                    borderColor: '#bbb',
                    bgcolor: '#f5f5f5'
                  }
                }}
              >
                Schließen
              </Button>
              <Button
                type="submit"
                form="update-products-form"
                variant="contained"
                size="large"
                fullWidth
                startIcon={<Save />}
                sx={{
                  bgcolor: '#2e7d32',
                  color: 'white',
                  fontWeight: 600,
                  textTransform: 'none',
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                  py: { xs: 1.2, sm: 1.5 },
                  borderRadius: '10px',
                  boxShadow: '0 4px 12px rgba(46, 125, 50, 0.3)',
                  order: { xs: 1, sm: 2 },
                  '&:hover': {
                    bgcolor: '#1b5e20',
                    boxShadow: '0 6px 16px rgba(46, 125, 50, 0.4)',
                    transform: 'translateY(-2px)'
                  },
                  transition: 'all 0.2s ease'
                }}
              >
                Produkte aktualisieren
              </Button>
            </DialogActions>
          </Dialog>
        )
        :
        <></>
    );
  }
}

export default UpdateProductsPopup;
